import React from "react";
import ReactDOM from "react-dom/client";
import CurrencyConverter from "./App";
import "./index.css"; 

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CurrencyConverter />
  </React.StrictMode>
);
